export default __webpack_public_path__ + "static/media/Group1296.cfa07eff.svg";